/**
 * @type {typeof import("@client/hooks.mjs").renderApplicationV2)
 * @param {foundry.applications.sheets.TokenConfig} app
 */
function baseExtendTokenConfig(app, html, _context, options) {
	if (options.parts && !options.parts.includes("appearance")) return;
	const hideBorder = foundry.applications.fields.createFormGroup({
		input: foundry.applications.fields.createCheckboxInput({
			name: "flags.hex-size-support.hideBorder",
			value: app.token.getFlag("hex-size-support", "hideBorder"),
		}),
		label: "hex-size-support.tokenConfig.hideBorder.label",
		localize: true,
		rootId: app.id,
	});
	const hideFill = foundry.applications.fields.createFormGroup({
		input: foundry.applications.fields.createCheckboxInput({
			name: "flags.hex-size-support.hideFill",
			value: app.token.getFlag("hex-size-support", "hideFill"),
		}),
		label: "hex-size-support.tokenConfig.hideFill.label",
		localize: true,
		rootId: app.id,
	});
	html.querySelector("[name=mirrorX]").closest(".form-group").after(hideBorder);
	if (game.settings.get("hex-size-support", "fillBorder")) hideBorder.after(hideFill);

	if (app.document?.parent.grid.isGridless) {
		html.querySelector('[name="width"]').step = 0.05;
		html.querySelector('[name="height"]').step = 0.05;
	}
}

/**
 * @type {typeof import("@client/hooks.mjs").renderApplicationV2)
 * @param {foundry.applications.sheets.TokenConfig} app
 */
export function extendTokenConfig(app, html, context, options) {
	if (options.parts && !options.parts.includes("appearance")) return;
	baseExtendTokenConfig(app, html, context, options);
	const grid = app.token.parent.grid;
	const gridShape = grid.isGridless ? "gridless" : grid.isHexagonal ? "hex" : "square";
	if (gridShape === "square") return;
	const initialShape = app.token.shape;
	/** @type {HTMLInputElement} */
	const input = foundry.utils.parseHTML(`\
		<input type="hidden"
			name="flags.hex-size-support.${gridShape}Shape"
			value="${app.token.shape}" data-dtype="Number">`);
	/** @type {HTMLSelectElement} */
	const shapeInput = html.querySelector('[name="shape"]');
	shapeInput?.addEventListener("change", function () {
		const value = parseInt(this.value);
		if (value !== initialShape) {
			this.insertAdjacentElement("afterend", input);
		} else input.remove();
		input.value = value;
	});
}

/**
 * @type {typeof import("@client/hooks.mjs").renderApplicationV2)
 * @param {foundry.applications.sheets.PrototypeTokenConfig} app
 */
export function extendPrototypeTokenConfig(app, html, context, options) {
	if (options.parts && !options.parts.includes("appearance")) return;
	baseExtendTokenConfig(app, html, context, options);
	const hexGroup = foundry.applications.fields.createFormGroup({
		input: foundry.applications.fields.createSelectInput({
			name: "flags.hex-size-support.hexShape",
			options: Object.entries(CONST.TOKEN_SHAPES).map(([label, value]) => ({
				value,
				label: `TOKEN.SHAPES.${label}.label`,
			})),
			localize: true,
			value: app.token.getFlag("hex-size-support", "hexShape"),
			blank: "Default",
			dataset: { dtype: "Number" },
		}),
		label: "hex-size-support.tokenConfig.hexShape.label",
		hint: "hex-size-support.tokenConfig.hexShape.hint",
		rootId: app.id,
		localize: true,
	});
	const gridlessGroup = foundry.applications.fields.createFormGroup({
		input: foundry.applications.fields.createSelectInput({
			name: "flags.hex-size-support.gridlessShape",
			options: [
				{ value: CONST.TOKEN_SHAPES.ELLIPSE_1, label: "TOKEN.SHAPES.ELLIPSE.label" },
				{ value: CONST.TOKEN_SHAPES.RECTANGLE_1, label: "TOKEN.SHAPES.RECTANGLE.label" },
			],
			localize: true,
			value: app.token.getFlag("hex-size-support", "gridlessShape"),
			blank: "Default",
			dataset: { dtype: "Number" },
		}),
		label: "hex-size-support.tokenConfig.gridlessShape.label",
		hint: "hex-size-support.tokenConfig.gridlessShape.hint",
		rootId: app.id,
		localize: true,
	});
	html.querySelector('.form-group:has(input[name="width"])')?.after(hexGroup);
	hexGroup.after(gridlessGroup);
}
